import api from '@/services/index.js'
async function open(callback) {
  setTimeout(async () => {
    await api
      .post('/prize-composite/v1/spins', { OpenBox: 'box_1' })
      .then((v) => {
        if (!v.success) {
          callback({ status: false, data: '', message: v.message })
        } else {
          callback({ status: true, data: v.data, message: v.message })
        }
      })
  }, 1000)
}
export { open }



// WEBPACK FOOTER //
// ./src/services/modules/spin.js